import React from 'react'
import { Text } from 'react-native'

import styles from '../../shared/styles'

// Header
export const HeaderLight = ({ title, ...other }) => <Text style={[styles.headerTitle, styles.cW]} {...other}>{title}</Text>
export const HeaderDark = ({ title, ...other }) => <Text style={[styles.headerTitle, styles.cD]} {...other}>{title}</Text>

// Sub Header
// export const SubheaderNormalDark = (props) => <span className="subheader-normal-dark" {...props}>{props.title}</span>
export const SubheaderBoldDark = (props) => <span className='subheader-bold-dark' {...props}>{props.title}</span>
export const SubheaderNormalRed = (props) => <span className='subheader-normal-red' {...props}>{props.title}</span>
export const SubheaderNormalGrey = (props) => <span className='subheader-normal-grey' {...props}>{props.title}</span>
export const SubheaderNormalWhite = (props) => <span className='subheader-normal-white' {...props}>{props.title}</span>

export const SubheaderNormalDark = (props) => <Text style={[styles.subHeader, styles.cD]}>{props.title}</Text>

// Button Title
export const ButtonTitleLight = (props) => <Text style={[styles.buttonTitle, styles.cW]}>{props.title}</Text>
export const ButtonTitleBlue = (props) => <Text style={[styles.buttonTitle, styles.cB]}>{props.title}</Text>
export const ButtonTitleDark = (props) => <Text style={[styles.buttonTitle, styles.cD]}>{props.title}</Text>

// Caption
export const CaptionNormalDark = (props) => <Text style={[styles.captionNormal, styles.cD]}>{props.title}</Text>
export const CaptionNormalLight = (props) => <Text style={[styles.captionNormal, styles.cW]}>{props.title}</Text>
export const CaptionBoldDark = (props) => <Text style={[styles.captionBold, styles.cD]}>{props.title}</Text>

// Body
export const BodyNormalDark = (props) => <Text style={[styles.BodyNormal, styles.cD]}>{props.title}</Text>
export const BodyBoldDark = (props) => <Text style={[styles.BodyBold, styles.cD]}>{props.title}</Text>
export const BodyNormalGrey = (props) => <Text style={[styles.BodyNormal, styles.cGey]}>{props.title}</Text>

export const BodySmallDark = (props) => <Text style={[styles.BodyNormal, styles.cD]}>{props.title}</Text>

export const LinkBlue = (props) => <Text style={[styles.linkLable, styles.cB]} {...props}>{props.title}</Text>
export const LinkAlert = (props) => <Text style={[styles.linkLable, styles.cA]} {...props}>{props.title}</Text>

export const ContainerDesc = (props) => <Text style={[styles.containDesc, styles.cD]}>{props.title}</Text>
export const ErrorMessage = (props) => <Text style={styles.errorTitle}>{props.title}</Text>

export const BoldTitle = ({ title, color }) => (
  <span className='bold-title' style={{ color: color || null }}>{title}</span>
)
